module.exports = __webpack_public_path__ + "img/janice-hero-alt.dc76920a.png";